import React from 'react';
import { Box, Typography } from '@mui/material';
import { CONFIG } from 'config-global';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                py: .5,
                textAlign: 'center',
                borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                mt: 'auto'
            }}
        >
            <Typography variant="body2" fontSize={12} color="text.secondary">
                © {currentYear} {CONFIG.appName}.
            </Typography>
        </Box>
    );
};

export default Footer;